import React, { FunctionComponent } from 'react'

import { useTheme } from 'styled-components/native'

import { AURORA_CDN_ASSETS_LINK_BASE } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/constants'

import { TreatmentRecImage, TreatmentRecViewport } from './TreatmentRecImage'
import {
  ASSETS_CDN_URL,
  AURORA_TREATMENT_REC_CDN_PREFIX,
  TREATMENT_REC_PRIMARY_CARD_CDN_PREFIX as namespace,
} from '../../constants'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'

const IMAGE_SIZES = {
  DESKTOP: {
    height: '356px',
    width: '416px',
  },
  TABLET: {
    height: '276px',
    width: '354px',
  },
  MOBILE: {
    height: '190px',
    width: '343px',
  },
}

/**
 * Illustration to show on the treatment card for Coaching
 */
export const CoachingRec: FunctionComponent<CoachingRecProps> = ({ viewport = 'DESKTOP' }) => {
  const { isAuroraTheme } = useTheme() as ThemeType
  const uri = isAuroraTheme
    ? `${AURORA_CDN_ASSETS_LINK_BASE}/${AURORA_TREATMENT_REC_CDN_PREFIX}coaching${viewport}.png`
    : ASSETS_CDN_URL + namespace + 'coaching' + viewport + '.png'

  return (
    <TreatmentRecImage
      viewport={viewport}
      uri={uri}
      testID={tID('CoachingRecIllustration')}
      isAuroraTheme={isAuroraTheme}
      imageSizes={IMAGE_SIZES}
    />
  )
}

export type CoachingRecProps = {
  viewport?: TreatmentRecViewport
}
